
import { mapState, mapMutations } from 'vuex'
import { removeMeta } from '~/utils/tools.js'
import FooterCardList from '~/components/library-center/footer-card-list.vue'
import LibSearchInput from '~/components/library-center/search-input.vue'
export default {
  components: {
    FooterCardList,
    LibSearchInput,
  },
  data() {
    return {
      dialogConf: {
        show: false,
        qrcode: '',
        active: '',
      },
    }
  },
  head: {
    title: '问卷满意度调查分析报告-市场调研表格模板-问卷网',
    meta: [
      {
        hid: 'keywords',
        name: 'keywords',
        content: '问卷,调查模板,问卷模板,问卷调查,调查问卷,调查分析报告,问卷调查表,满意度调查,市场调查问卷',
      },
      {
        hid: 'description',
        name: 'description',
        content:
          '问卷网(www.wenjuan.com)拥有内容丰富的问卷模板库，由专业研究员设计和会员共享的海量市场调查问卷模板、调查问卷格式，让你轻松制作各类调查问卷、调研分析报告，进行问卷调查表设计等',
      },
    ],
  },
  computed: {
    ...mapState(['loginStatus', 'headerActive', 'mediaType']),
  },
  mounted() {
    this.setHightLightHeader({
      active: 'lib',
    })
    removeMeta('applicable-device')
  },
  methods: {
    ...mapMutations(['setHightLightHeader']),
  },
}
